export default [
    {
        path: 'approvalIndex',
        name: 'approvalIndex',
        component: resolve => require(['@/view/data_input/approval.vue'], resolve)
    },
    {
        path: 'Publish',
        name: 'Publish',
        component: resolve => require(['@/view/data_input/publish.vue'], resolve)
    },
    {
        path: 'RejectList',
        name: 'RejectList',
        component: resolve => require(['@/view/data_input/RejectList.vue'], resolve)
    },
    {
        path: '/MassUploadLog',
        name: 'MassUploadLog',
        component: resolve => require(['@/view/data_input/NoticePage/MassUploadLog.vue'], resolve)
    },
    {
        path: 'select_code',
        name: 'select_code',
        component: resolve => require(['@/view/BPM/ChangeProductSelection/index.vue'], resolve)
    },
    {
        path: 'select_code_success',
        name: 'select_code_success',
        component: resolve => require(['@/view/BPM/ChangeProductSelection/success.vue'], resolve)
    },
    {
        path: 'select_code_publish',
        name: 'select_code_publish',
        component: resolve => require(['@/view/BPM/ChangePublish/index.vue'], resolve)
    },
    {
        path: '/BaseABM',
        name: 'BaseABM',
        component: resolve => require(['@/view/BPM/ChangeInput/ABM/ABM_Base.vue'], resolve)
    },
    {
        path: '/BaseCategory_MSP',
        name: 'BaseCategory_MSP',
        component: resolve => require(['@/view/BPM/ChangeInput/Category_MSP/Category_MSP_Base.vue'], resolve)
    },
    {
        path: '/BaseMDS',
        name: 'BaseMDS',
        component: resolve => require(['@/view/BPM/ChangeInput/MDS/MDS_Base.vue'], resolve)
    },
    {
        path: '/BaseRBU',
        name: 'BaseRBU',
        component: resolve => require(['@/view/BPM/ChangeInput/RBU/RBU_Base.vue'], resolve)
    },
    {
        path: '/PriceRBU',
        name: 'PriceRBU',
        component: resolve => require(['@/view/BPM/ChangeInput/RBU/RBU_Price.vue'], resolve)
    },
    {
        path: '/PriceMDS',
        name: 'PriceMDS',
        component: resolve => require(['@/view/BPM/ChangeInput/MDS/MDS_Price.vue'], resolve)
    },
    {
        path: '/priceApproval',
        name: 'priceApproval',
        component: resolve => require(['@/view/BPM/ChangeApproval/index.vue'], resolve)
    },
    {
        path: '/onlineReport',
        name: 'onlineReport',
        component: resolve => require(['@/view/BPM/X2/OnlineReport/index.vue'], resolve)
    },
    {
        path: '/SPIGReport',
        name: 'SPIGReport',
        component: resolve => require(['@/view/BPM/report/SPIGReport/index.vue'], resolve)
    },
    {
        path: '/ni-report',
        name: 'NIReport',
        component: resolve => require(['@/view/BPM/report/NIReport/index.vue'], resolve)
    },
    {
        path: '/PriceListPreparation',
        name: 'PriceListPreparation',
        component: resolve => require(['@/view/BPM/X2/PriceListPreparation/index.vue'], resolve)
    },
    {
        path: '/PriceListPublish',
        name: 'PriceListPublish',
        component: resolve => require(['@/view/BPM/X2/PriceListPublish/index.vue'], resolve)
    },
    {
        path: '/ReportsDownloadCenter',
        name: 'ReportsDownloadCenter',
        component: resolve => require(['@/view/BPM/X2/ReportsDownloadCenter/index.vue'], resolve)
    },
    {
        path: 'InputStatus',
        name: 'InputStatus',
        component: resolve => require(['@/view/data_input/input_status.vue'], resolve)
    },
    {
        path: 'Validate',
        name: 'Validate',
        component: resolve => require(['@/view/data_input/validate.vue'], resolve)
    },
    {
        path: 'Approval',
        name: 'Approval',
        component: resolve => require(['@/view/data_input/approval_assign.vue'], resolve)
    },
    {
        path: 'InputAbm',
        name: 'InputAbm',
        component: resolve => require(['@/view/data_input/input_abm.vue'], resolve)
    },
    {
        path: 'CagegoryMsp',
        name: 'CagegoryMsp',
        component: resolve => require(['@/view/data_input/category_msp.vue'], resolve)
    },
    {
        path: 'bpm-setting',
        name: 'bpm-setting',
        component: resolve => require(['@/view/select_codes/pre_conditon.vue'], resolve)
    },
    {
        path: 'select_product',
        name: 'select_product',
        component: resolve => require(['@/view/select_product/select_product.vue'], resolve)
    },
    {
        path: 'code_success',
        name: 'Submit Success',
        component: resolve => require(['@/view/select_product/code_success.vue'], resolve)
    },
    {
        path: 'success',
        name: 'success',
        component: resolve => require(['@/view/data_input/success.vue'], resolve)
    },
    {
        path: 'ReportCenterCart',
        name: 'ReportCenterCart',
        component: resolve => require(['@/view/data_input/ReportCenter.vue'], resolve)
    },
    {
        path: 'Input',
        name: 'Input',
        component: resolve => require(['@/view/data_input/input_mds.vue'], resolve)
    },
    {
        path: 'RBUFA',
        name: 'RBUFA',
        component: resolve => require(['@/view/data_input/input_rbufa.vue'], resolve)
    },
    {
        path: 'cycle_select',
        name: 'cycle_select',
        component: resolve => require(['@/view/select_product/cycle_select.vue'], resolve)
    },
    {
        path: 'approval-fa-group-manager',
        name: 'approval_fa_group_manager',
        component: resolve => require(['@/view/approval/approval_fa_group_manager/approval_fa_group_manager.vue'], resolve)
    },
    {
        path: 'approval-ncsm',
        name: 'approval_ncsm',
        component: resolve => require(['@/view/approval/approval_ncsm/approval_ncsm.vue'], resolve)
    },
    {
        path: 'approval-bm',
        name: 'approval_bm',
        component: resolve => require(['@/view/approval/approval_bm/approval_bm.vue'], resolve)
    },
    {
        path: '/processB/changeIndex',
        name: 'changeIndex',
        component: resolve => require(['@/view/BPM/processB/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/cycle-select',
        name: 'SCCycleSelect',
        component: resolve => require(['@/view/specialChannel/priceList/selectProduct/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/select-product',
        name: 'SCSelectProdect',
        component: resolve => require(['@/view/specialChannel/priceList/selectProduct/select_product.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/code-success',
        name: 'SCSelectProdectCodeSuccess',
        component: resolve => require(['@/view/specialChannel/priceList/selectProduct/code_success.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/gtm-spoc',
        name: 'SCGTMSPOCInput',
        component: resolve => require(['@/view/specialChannel/priceList/dataInput/gtmSpoc.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/mds',
        name: 'SCMDSInput',
        component: resolve => require(['@/view/specialChannel/priceList/dataInput/mds.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/rbu-fa',
        name: 'SCFAInput',
        component: resolve => require(['@/view/specialChannel/priceList/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/validation',
        name: 'SCPricelistValidate',
        component: resolve => require(['@/view/specialChannel/priceList/dataValidation/validation/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/approvalMgt',
        name: 'SCPricelistApprovalMgt',
        component: resolve => require(['@/view/specialChannel/priceList/dataValidation/approvalMgt/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/reject-list',
        name: 'SCPricelistRejectList',
        component: resolve => require(['@/view/specialChannel/priceList/dataValidation/rejectedList/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/bm-approval',
        name: 'SCPricelistBMApproval',
        component: resolve => require(['@/view/specialChannel/priceList/approval/bmApproval/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/csm-approval',
        name: 'SCPricelistCSMApproval',
        component: resolve => require(['@/view/specialChannel/priceList/approval/csmApproval/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/fm-approval',
        name: 'SCPricelistFMApproval',
        component: resolve => require(['@/view/specialChannel/priceList/approval/fmApproval/index.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/success',
        name: 'SCPricelistSuccess',
        component: resolve => require(['@/view/specialChannel/components/success/success.vue'], resolve)
    },
    {
        path: 'special-channel/price-list/publish',
        name: 'SCPricelistpublish',
        component: resolve => require(['@/view/specialChannel/priceList/publish/index.vue'], resolve)
    },
    {
        path: 'special-channel/report/fpc-status-report',
        name: 'SCReportFPC',
        component: resolve => require(['@/view/specialChannel/report/FPCStatus/index.vue'], resolve)
    },
    // A3 A4开始
    {
        path: 'special-channel/product-priceChange/cycle-select',
        name: 'SCProductPriceCycleSelect',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeProductSelection/index.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/selectSuccess',
        name: 'SCProductPriceSelectSuccess',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeProductSelection/success.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/gtm',
        name: 'SCProductPriceGTM',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeInput/GTM_SPOC/GTM_SPOC.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/mds_price',
        name: 'SCProductPriceMdsPrice',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeInput/MDS/MDS_Price.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/mds_product',
        name: 'SCProductPriceMdsProduct',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeInput/MDS/MDS_Product.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/rbu_price',
        name: 'SCProductPriceRbuPrice',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeInput/RBU/RBU_Price.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/BMapproval',
        name: 'SCProductPriceBMApproval',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeApproval/BMApproval.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/CSMapproval',
        name: 'SCProductPriceCSMApproval',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeApproval/CSMApproval.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/FMapproval',
        name: 'SCProductPriceFMApproval',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangeApproval/FMApproval.vue'], resolve)
    },
    {
        path: 'special-channel/product-priceChange/publist',
        name: 'SCProductPricePublist',
        component: resolve => require(['@/view/specialChannel/product_priceChange/ChangePublish/index.vue'], resolve)
    },
    {
        path: 'dstc/price-list/success',
        name: 'DSTCPricelistSuccess',
        component: resolve => require(['@/view/DSTC/components/success/success.vue'], resolve)
    },
    // A3 A4结束
    //DSTC D1开始
    {
        path: 'DSTC/D1/select-product/quarter-select',
        name: 'DSTCD1SelectProductQuarterSelect',
        component: resolve => require(['@/view/DSTC/D1/selectProduct/select_quarter.vue'], resolve)
    },
    {
        path: 'DSTC/D1/select-product/product-select',
        name: 'DSTCD1SelectProductProductSelect',
        component: resolve => require(['@/view/DSTC/D1/selectProduct/select_product.vue'], resolve)
    },
    {
        path: 'DSTC/D1/select-product/select-success',
        name: 'DSTCD1SelectProductSelectSuccess',
        component: resolve => require(['@/view/DSTC/D1/selectProduct/select_success.vue'], resolve)
    },
    {
        path: 'DSTC/D1/data-input/gtmspoc',
        name: 'DSTCD1DataInputGtmspoc',
        component: resolve => require(['@/view/DSTC/D1/dataInput/gtmSpoc.vue'], resolve)
    },
    {
        path: 'DSTC/D1/data-input/mds',
        name: 'DSTCD1DataInputMds',
        component: resolve => require(['@/view/DSTC/D1/dataInput/mds.vue'], resolve)
    },
    {
        path: 'DSTC/D1/approval/csm',
        name: 'DSTCD1ApprovalCsm',
        component: resolve => require(['@/view/DSTC/D1/approval/CSMApproval.vue'], resolve)
    },
    {
        path: 'DSTC/D1/dataValidation/validation',
        name: 'DSTCD1DataValidationValidation',
        component: resolve => require(['@/view/DSTC/D1/dataValidation/validation/index.vue'], resolve)
    },
    {
        path: 'DSTC/D1/dataValidation/rejected-list',
        name: 'DSTCD1DataValidationRejectedList',
        component: resolve => require(['@/view/DSTC/D1/dataValidation/rejectedList/index.vue'], resolve)
    },
    {
        path: 'DSTC/D1/publish',
        name: 'DSTCD1Publish',
        component: resolve => require(['@/view/DSTC/D1/publish/index.vue'], resolve)
    },
    //DSTC D1结束
    //DSTC A5开始
    {
        path: 'DSTC/A5/select-product/product-select',
        name: 'DSTCA5SelectProductProductSelect',
        component: resolve => require(['@/view/DSTC/A5/ChangeProductSelection/select_product.vue'], resolve)
    },
    {
        path: 'DSTC/A5/select-product/select-success',
        name: 'DSTCA5SelectProductSelectSuccess',
        component: resolve => require(['@/view/DSTC/A5/ChangeProductSelection/select_success.vue'], resolve)
    },
    {
        path: 'DSTC/A5/changeInput/gtm_product',
        name: 'DSTCA5GTMProduct',
        component: resolve => require(['@/view/DSTC/A5/ChangeInput/GTM_SPOC/GTM_SPOC_Product.vue'], resolve)
    },
    {
        path: 'DSTC/A5/changeInput/mds_product',
        name: 'DSTCA5MdsProduct',
        component: resolve => require(['@/view/DSTC/A5/ChangeInput/MDS/MDS_Product.vue'], resolve)
    },
    {
        path: 'DSTC/A5/changeApproval/CSMapproval',
        name: 'DSTCA5CSMApproval',
        component: resolve => require(['@/view/DSTC/A5/ChangeApproval/CSMApproval.vue'], resolve)
    },
    {
        path: 'DSTC/A5/changePublish/publish',
        name: 'DSTCA5Publish',
        component: resolve => require(['@/view/DSTC/A5/ChangePublish/index.vue'], resolve)
    },
    {
        path: 'DSTC/fpcStatusReport',
        name: 'DSTCFPCStatusReport',
        component: resolve => require(['@/view/DSTC/report/FPCStatus/index.vue'], resolve)
    },
    {
        path: 'DSTC/internalReport',
        name: 'DSTCInternalReport',
        component: resolve => require(['@/view/DSTC/report/InternalReport/index.vue'], resolve)
    },
    //DSTC A5结束
    // N1 选品
    {
        path: 'non-sale/n1/select-product',
        name: 'N1SelectProduct',
        component: resolve => require(['@/view/Non-Sale/N1/selectProduct/index.vue'], resolve)
    },
    {
        path: 'non-sale/n1/select-product-success',
        name: 'N1SelectProductSuccess',
        component: resolve => require(['@/view/Non-Sale/N1/selectProduct/success.vue'], resolve)
    },
    // data input
    {
        path: 'non-sale/n1/data-input/mds',
        name: 'N1MdsDataInput',
        component: resolve => require(['@/view/Non-Sale/N1/dataInput/mds.vue'], resolve)
    },
    {
        path: 'non-sale/n1/data-input/rbufa',
        name: 'N1RBUFADataInput',
        component: resolve => require(['@/view/Non-Sale/N1/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'non-sale/n1/reject-list',
        name: 'N1Rejectlist',
        component: resolve => require(['@/view/Non-Sale/N1/dataValidation/rejectedList/index.vue'], resolve)
    },
    {
        path: 'non-sale/n1/validation',
        name: 'N1Validation',
        component: resolve => require(['@/view/Non-Sale/N1/dataValidation/validation/index.vue'], resolve)
    },
    {
        path: 'non-sale/n1/publish',
        name: 'N1Publish',
        component: resolve => require(['@/view/Non-Sale/N1/publish/index.vue'], resolve)
    },
    {
        path: 'non-sale/n1/approval/fm',
        name: 'N1APPROVALFM',
        component: resolve => require(['@/view/Non-Sale/N1/approval/fm.vue'], resolve)
    },
    {
        path: 'non-sale/n1/approval/bm',
        name: 'N1BM',
        component: resolve => require(['@/view/Non-Sale/N1/approval/bm.vue'], resolve)
    },
    // approval publish 成功页
    {
        path: 'non-sale/n1/success',
        name: 'N1SUCCESS',
        component: resolve => require(['@/view/Non-Sale/components/success/index.vue'], resolve)
    },
    // fpc report
    {
        path: 'non-sale/n1/fpc-report',
        name: 'N1FPCReport',
        component: resolve => require(['@/view/Non-Sale/N1/report/FPCStatus'], resolve)
    },
    // A6 选品
    {
        path: 'non-sale/a6/select-product',
        name: 'A6SelectProduct',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeSelection/index.vue'], resolve)
    },
    // A6 选品成功页
    {
        path: 'non-sale/a6/select-product/success',
        name: 'A6SelectProductSuccess',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeSelection/success.vue'], resolve)
    },
    // A6 change input MDS
    {
        path: 'non-sale/a6/change/mds',
        name: 'A6ChangeMDS',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeInput/mds.vue'], resolve)
    },
    {
        path: 'non-sale/a6/change/rbu',
        name: 'A6ChangeRBUFA',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeInput/rbu.vue'], resolve)
    },
    // A6 Approval
    {
        path: 'non-sale/a6/approval/bm',
        name: 'A6ChangeBM',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeApproval/bm.vue'], resolve)
    },
    {
        path: 'non-sale/a6/approval/fm',
        name: 'A6ChangeFM',
        component: resolve => require(['@/view/Non-Sale/A6/ChangeApproval/fm.vue'], resolve)
    },
    // A6 SAP Change page
    {
        path: 'non-sale/a6/sap-change',
        name: 'A6SAPChange',
        component: resolve => require(['@/view/Non-Sale/A6/SAPChange/index.vue'], resolve)
    },
    // A6 publish page
    {
        path: 'non-sale/a6/publish',
        name: 'A6PUBLISH',
        component: resolve => require(['@/view/Non-Sale/A6/publish/index.vue'], resolve)
    },
    // DTC开始
    {
        path: 'dtc-select',
        name: 'dtcSelectProduct',
        component: resolve => require(['@/view/DTC/D1/selectProduct/index.vue'], resolve)
    },
    {
        path: 'dtc-select-success',
        name: 'dtcSuccess',
        component: resolve => require(['@/view/DTC/D1/selectProduct/success.vue'], resolve)
    },
    {
        path: 'data-input-rbu',
        name: 'dtcInputRBU',
        component: resolve => require(['@/view/DTC/D1/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'dtc/data-input-mds',
        name: 'dtcInputMDS',
        component: resolve => require(['@/view/DTC/D1/dataInput/mds.vue'], resolve)
    },
    {
        path: 'dtc/bm-approval',
        name: 'DTCBMApproval',
        component: resolve => require(['@/view/DTC/D1/approval/bm.vue'], resolve)
    },
    {
        path: 'dtc-fm-approval',
        name: 'dtcFMApproval',
        component: resolve => require(['@/view/DTC/D1/approval/fm.vue'], resolve)
    },
    {
        path: 'dtc-fm-approval-success',
        name: 'dtcApprovalSuccess',
        component: resolve => require(['@/view/DTC/D1/approval/success.vue'], resolve)
    },
    {
        path: 'dtc-SAPUploadPage',
        name: 'dtcSAPChange',
        component: resolve => require(['@/view/DTC/D1/SAPChange/index.vue'], resolve)
    },
    // DTC结束
    // DTC Change 开始
    {
        path: 'dtc-change/select-product',
        name: 'dtcChangeSelectProduct',
        component: resolve => require(['@/view/DTC/A7/ChangeSelectProduct/index.vue'], resolve)
    },
    {
        path: 'dtc-change/select-product-success',
        name: 'dtcChangeSuccess',
        component: resolve => require(['@/view/DTC/A7/ChangeSelectProduct/success.vue'], resolve)
    },
    {
        path: 'dtc-change/input-rbu-fa',
        name: 'dtcChangeInputRBU',
        component: resolve => require(['@/view/DTC/A7/ChangeDataInput/rbufa.vue'], resolve)
    },
    {
        path: 'dtc-change/fm-approval',
        name: 'dtcChangeFMApproval',
        component: resolve => require(['@/view/DTC/A7/ChangeApproval/fm.vue'], resolve)
    },
    {
        path: 'dtc-change/fm-approval-success',
        name: 'dtcChangeApprovalSuccess',
        component: resolve => require(['@/view/DTC/A7/ChangeApproval/success.vue'], resolve)
    },
    {
        path: 'dtc-change/sap-change-page',
        name: 'dtcChangeSAPChange',
        component: resolve => require(['@/view/DTC/A7/SAPChange/index.vue'], resolve)
    },
    // DTC Change 结束
    // baseprice 选品
    {
        path: 'base-price/select-product',
        name: 'BPSelectProduct',
        component: resolve => require(['@/view/basePrice/selectProduct/index.vue'], resolve)
    },
    {
        path: 'base-price/select-product-success',
        name: 'BPSelectProductSuccess',
        component: resolve => require(['@/view/basePrice/selectProduct/success.vue'], resolve)
    },
    // data input
    {
        path: 'base-price/data-input/mds',
        name: 'BPMdsDataInput',
        component: resolve => require(['@/view/basePrice/dataInput/mds.vue'], resolve)
    },
    {
        path: 'base-price/data-input/rbufa',
        name: 'BPRBUDataInput',
        component: resolve => require(['@/view/basePrice/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'base-price/fm-approval',
        name: 'BPAPPROVALFM',
        component: resolve => require(['@/view/basePrice/approval/fm.vue'], resolve)
    },
    {
        path: 'base-price/fm-approval/success',
        name: 'BPAPPROVALFMSUCCESS',
        component: resolve => require(['@/view/basePrice/approval/success.vue'], resolve)
    },
    {
        path: 'base-price/sap-change',
        name: 'BPSAPCHANGE',
        component: resolve => require(['@/view/basePrice/SAPChange/index.vue'], resolve)
    },
    // DTC Change 开始
    {
        path: 'dtc-change/dtc-select',
        name: 'dtcSelectProduct',
        component: resolve => require(['@/view/DTC/A7/ChangeSelectProduct/index.vue'], resolve)
    },
    {
        path: 'dtc-change/dtc-select-success',
        name: 'dtcSuccess',
        component: resolve => require(['@/view/DTC/A7/ChangeSelectProduct/success.vue'], resolve)
    },
    {
        path: 'dtc-change/data-input-rbu',
        name: 'dtcInputRBU',
        component: resolve => require(['@/view/DTC/A7/ChangeDataInput/rbufa.vue'], resolve)
    },
    {
        path: 'dtc/change-mds',
        name: 'DTCChangeInputMDS',
        component: resolve => require(['@/view/DTC/A7/ChangeDataInput/mds.vue'], resolve)
    },
    {
        path: 'dtc/bm-change-approval',
        name: 'dtcChangeBMApproval',
        component: resolve => require(['@/view/DTC/A7/ChangeApproval/bm.vue'], resolve)
    },
    {
        path: 'dtc-change/dtc-fm-approval',
        name: 'dtcFMApproval',
        component: resolve => require(['@/view/DTC/A7/ChangeApproval/fm.vue'], resolve)
    },
    {
        path: 'dtc-change/dtc-fm-approval-success',
        name: 'dtcApprovalSuccess',
        component: resolve => require(['@/view/DTC/A7/ChangeApproval/success.vue'], resolve)
    },
    {
        path: 'dtc-change/dtc-SAPUploadPage',
        name: 'dtcSAPChange',
        component: resolve => require(['@/view/DTC/A7/SAPChange/index.vue'], resolve)
    },
    // DTC Change 结束
    // HK
    {
        path: 'hk/product-hierarchy',
        name: 'HKPRODUCTHIERARCHY',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKProductHierarchy/index.vue'], resolve)
    },
    {
        path: 'hk/hierarchy-config',
        name: 'HKHIERARCHYCONFIG',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKPHierarchyConfig/index.vue'], resolve)
    },
    {
        path: 'hk/price-list/code-select',
        name: 'HKPRICELISTCODESELECT',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/codeSelection/index.vue'], resolve)
    },
    {
        path: 'hk/price-list/code-select-success',
        name: 'HKPRICELISTCODESELECTSUCCESS',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/codeSelection/success.vue'], resolve)
    },
    {
        path: 'hk/price-list/msp',
        name: 'HKPRICELISTMSP',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/dataInput/msp.vue'], resolve)
    },
    {
        path: 'hk/price-list/brand-team',
        name: 'HKPRICELISTBRANDTEAM',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/dataInput/brand-team.vue'], resolve)
    },
    {
        path: 'hk/price-list/rbu-fa',
        name: 'HKPRICELISTRBUFA',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'hk/price-list/smo-msp-approve',
        name: 'HKPRICELISTSMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/approval/msp.vue'], resolve)
    },
    {
        path: 'hk/price-list/smo-fm-approve',
        name: 'HKPRICELISTSMOFMAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/approval/fm.vue'], resolve)
    },
    {
        path: 'hk/price-list/rbu-approve',
        name: 'HKPRICELISTRBUAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/approval/fa.vue'], resolve)
    },
    {
        path: 'hk/price-list/publish',
        name: 'HKPRICELISTRBUPUBLISH',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/publish/index.vue'], resolve)
    },
    // HKCustomerCode
    {
        path: 'hk/customer-code',
        name: 'HKCUSTOMERCODE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKCustomerCode/index.vue'], resolve)
    },
    {
        path: 'hktw/mass-upload-log',
        name: 'HKTWMASSUPLOADLOG',
        component: resolve => require(['@/view/HKTW/components/massUpload/log.vue'], resolve)
    },
    {
        path: 'hk/photo-shot',
        name: 'HKPHOTOSHOT',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKPhotoShop/index.vue'], resolve)
    },
    // TWCustomerCode
    {
        path: 'tw/customer-code',
        name: 'TWCUSTOMERCODE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWCustomerCode/index.vue'], resolve)
    },
    {
        path: 'hk/price-list/permit',
        name: 'HKPRICELISTPERMIT',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalPriceList/permit/index.vue'], resolve)
    },
    {
        path: 'hk/change/code-select',
        name: 'HKCHANGECODESELECT',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/codeSelection/index.vue'], resolve)
    },
    {
        path: 'hk/change/code-select-success',
        name: 'HKCHANGECODESELECTSUCCESS',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/codeSelection/success.vue'], resolve)
    },
    {
        path: 'hk/change/msp',
        name: 'HKCHANGEMSP',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeInput/msp.vue'], resolve)
    },
    {
        path: 'hk/change/brandTeam',
        name: 'HKCHANGEMDS',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeInput/brandTeam.vue'], resolve)
    },
    {
        path: 'hk/change/rbu-fa',
        name: 'HKCHANGERBUFA',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeInput/rbufa.vue'], resolve)
    },
    {
        path: 'hk/change/smo-msp-approve',
        name: 'HKCHANGESMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeApproval/msp.vue'], resolve)
    },
    {
        path: 'hk/change/smo-fm-approve',
        name: 'HKCHANGESMOFMAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeApproval/fm.vue'], resolve)
    },
    {
        path: 'hk/change/rbu-approve',
        name: 'HKCHANGERBUAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changeApproval/fa.vue'], resolve)
    },
    {
        path: 'hk/change/permit',
        name: 'HKCHANGEERMIT',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changePermit/index.vue'], resolve)
    },
    {
        path: 'hk/change/publish',
        name: 'HKCHANGERBUpublish',
        component: resolve => require(['@/view/HKTW/HKMasterData/HKNormalChange/changePublish/index.vue'], resolve)
    },
    // Report Center
    {
        path: 'hk/fpc-status-report',
        name: 'HKFPCSTATUSREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/FPCStatusReport/HK/index.vue'], resolve)
    },
    {
        path: 'hk/price-online-report',
        name: 'HKONLINEREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/OnlineReport/HK/index.vue'], resolve)
    },
    // TW
    {
        path: 'tw/product-hierarchy',
        name: 'TWPRODUCTHIERARCHY',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWProductHierarchy/index.vue'], resolve)
    },
    // gtm
    {
        path: 'product-report/gtm-data-readiness',
        name: 'PRODUCTREPORTGTMDATAREADINESS',
        component: resolve => require(['@/view/BPM/report/GTMDataReadiness/index.vue'], resolve)
    },
    {
        path: 'tw/photo-shot',
        name: 'TWPHOTOSHOT',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWPhotoShot/index.vue'], resolve)
    },
    {
        path: 'tw/hierarchy-config',
        name: 'TWHIERARCHYCONFIG',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWPHierarchyConfig/index.vue'], resolve)
    },
    {
        path: 'tw/price-list/code-select',
        name: 'TWPRICELISTCODESELECT',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/codeSelection/index.vue'], resolve)
    },
    {
        path: 'tw/price-list/code-select-success',
        name: 'TWPRICELISTCODESELECTSUCCESS',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/codeSelection/success.vue'], resolve)
    },
    {
        path: 'tw/price-list/msp',
        name: 'TWPRICELISTMSP',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/dataInput/msp.vue'], resolve)
    },
    {
        path: 'tw/price-list/brand-team',
        name: 'TWPRICELISTRBANDTEAM',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/dataInput/brand-team.vue'], resolve)
    },
    {
        path: 'tw/price-list/rbu-fa',
        name: 'TWPRICELISTRBUFA',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/dataInput/rbufa.vue'], resolve)
    },
    {
        path: 'tw/price-list/smo-msp-approve',
        name: 'TWPRICELISTSMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/approval/msp.vue'], resolve)
    },
    {
        path: 'tw/price-list/smo-fm-approve',
        name: 'TWPRICELISTSMOFMAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/approval/fm.vue'], resolve)
    },
    {
        path: 'tw/price-list/rbu-approve',
        name: 'TWPRICELISTRBUAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/approval/fa.vue'], resolve)
    },
    {
        path: 'tw/price-list/publish',
        name: 'TWPRICELISTRBUPUBLISH',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalPriceList/publish/index.vue'], resolve)
    },
    // tw change
    {
        path: 'tw/change/code-select',
        name: 'TWCHANGESELECT',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/codeSelection/index.vue'], resolve)
    },
    {
        path: 'tw/change/code-select-success',
        name: 'TWCHANGESELECTSUCCESS',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/codeSelection/success.vue'], resolve)
    },
    {
        path: 'tw/change/msp',
        name: 'TWCHANGEMSP',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeInput/msp.vue'], resolve)
    },
    {
        path: 'tw/change/brand-team',
        name: 'TWCHANGERBANDTEAM',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeInput/brandTeam.vue'], resolve)
    },
    {
        path: 'tw/change/rbu-fa',
        name: 'TWCHANGERBUFA',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeInput/rbufa.vue'], resolve)
    },
    {
        path: 'tw/change/smo-msp-approve',
        name: 'TWCHANGESMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeApproval/msp.vue'], resolve)
    },
    {
        path: 'tw/change/smo-fm-approve',
        name: 'TWCHANGESMOFMAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeApproval/fm.vue'], resolve)
    },
    {
        path: 'tw/change/rbu-approve',
        name: 'TWCHANGERBUAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changeApproval/fa.vue'], resolve)
    },
    {
        path: 'tw/change/publish',
        name: 'TWCHANGERBUPUBLISH',
        component: resolve => require(['@/view/HKTW/TWMasterData/TWNormalChange/changePublish/index.vue'], resolve)
    },
    {
        path: 'tw/fpc-status-report',
        name: 'TWFPCSTATUSREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/FPCStatusReport/TW/index.vue'], resolve)
    },
    {
        path: 'tw/price-online-report',
        name: 'TWONLINEREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/OnlineReport/TW/index.vue'], resolve)
    },
  {
        path: 'hktw/csa-report',
        name: 'CSAREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/CSAReport/index.vue'], resolve)
    },
    {
        path: 'hktw/change-upload-page',
        name: 'TWONLINEREPORT',
        component: resolve => require(['@/view/HKTW/ReportCenter/ChangeUploadPage/index.vue'], resolve)
    },
    {
        path: 'hktw/change-index',
        name: 'HKTWCHANGEINDEX',
        component: resolve => require(['@/view/HKTW/ReportCenter/changeIndex/index.vue'], resolve)
    },
    {
        path: 'cdda/code-select',
        name: 'CDDASELECT',
        component: resolve => require(['@/view/CDDA/codeSelection/index.vue'], resolve)
    },
    {
        path: 'cdda/code-select/success',
        name: 'CDDASELECTSUCCESS',
        component: resolve => require(['@/view/CDDA/codeSelection/success.vue'], resolve)
    },
    {
        path: 'cdda/data-input',
        name: 'CDDADATAINPUT',
        component: resolve => require(['@/view/CDDA/dataInput/index.vue'], resolve)
    },
    {
        path: 'cdda/request-status',
        name: 'CDDAREQUESTSTATUS',
        component: resolve => require(['@/view/CDDA/requestStatus/index.vue'], resolve)
    },
    {
        path: 'tw/special-channel/data-input',
        name: 'TWSPECIALCHANNELDATAINPUT',
        component: resolve => require(['@/view/HKTW/TWMasterData/specialChannel/dataInput/index.vue'], resolve)
    },
    {
        path: 'tw/special-channel/smo-msp-approve',
        name: 'TWSPECIALCHANNELSMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/specialChannel/approval/msp.vue'], resolve)
    },
    {
        path: 'tw/special-channel/rbu-approve',
        name: 'TWSPECIALCHANNELRBUAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/specialChannel/approval/rbu.vue'], resolve)
    },
    {
        path: 'tw/special-channel/fm-approve',
        name: 'TWSPECIALCHANNELFMAPPROVE',
        component: resolve => require(['@/view/HKTW/TWMasterData/specialChannel/approval/fm.vue'], resolve)
    },
    {
        path: 'hk/special-channel/data-input',
        name: 'HKSPECIALCHANNELDATAINPUT',
        component: resolve => require(['@/view/HKTW/HKMasterData/specialChannel/dataInput/index.vue'], resolve)
    },
    {
        path: 'hk/special-channel/smo-msp-approve',
        name: 'HKSPECIALCHANNELSMOMSPAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/specialChannel/approval/msp.vue'], resolve)
    },
    {
        path: 'hk/special-channel/rbu-approve',
        name: 'HKSPECIALCHANNELRBUAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/specialChannel/approval/rbu.vue'], resolve)
    },
    {
        path: 'hk/special-channel/fm-approve',
        name: 'HKSPECIALCHANNELFMAPPROVE',
        component: resolve => require(['@/view/HKTW/HKMasterData/specialChannel/approval/fm.vue'], resolve)
    },
    {
        path: 'gtin',
        name: 'GTIN',
        component: resolve => require(['@/view/GTIN/index.vue'], resolve)
    },
    {
        path: 'hktw/hierarchy-tree',
        name: 'HIERARCHYTREE',
        component: resolve => require(['@/view/HKTW/ReportCenter/HierarchyTree/index.vue'], resolve)
    },

    // 重构CMR的页面
    {
        path: 'cmr/ProductLocalHierarchy-new',
        name: 'PRODUCTLOCALHIERARCHY-NEW',
        component: resolve => require(['@/view/cmr_refactor/reports/productLocalHierarchy/index.vue'], resolve)
    },
    {
        path: 'cmr/ProductMasterData-new',
        name: 'PRODUCTLOCALHIERARCHY-NEW',
        component: resolve => require(['@/view/cmr_refactor/reports/ProductMasterData/index.vue'], resolve)
    },
    {
        path: '/cmr/MaintainProductHierarchy-new',
        name: 'MAINTAINPRODUCTHIERARCHY-NEW',
        component: resolve => require(['@/view/cmr_refactor/reports/maintainProductHierarchy/index.vue'], resolve)
    },
    {
        path: '/cmr/MaintainProductHierarchyDetail-new',
        name: 'MAINTAINPRODUCTHIERARCHYDETAIL-NEW',
        component: resolve => require(['@/view/cmr_refactor/reports/maintainProductHierarchy/detail.vue'], resolve)
    },
    {
        path: '/cmr/MaintainProductHierarchyEdit-new',
        name: 'MAINTAINPRODUCTHIERARCHYEDIT-NEW',
        component: resolve => require(['@/view/cmr_refactor/reports/maintainProductHierarchy/edit.vue'], resolve)
    },
    {
        path: '/report/NIProduct-new',
        name: 'NIPRODUCT',
        component: resolve => require(['@/view/BPM/report/NIProduct/index.vue'], resolve)
    },
    {
        path: '/MasterDataCheckCenter',
        name: 'MASTERDATACHECKCENTER',
        component: resolve => require(['@/view/SMILE/MasterDataCheckCenter/index.vue'], resolve)
    },
    {
        path: '/AdditionalRequest',
        name: 'ADDITIONALREQUEST',
        component: resolve => require(['@/view/SMILE/AdditionalRequest/index.vue'], resolve)
    },
    {
        path: '/AdditionalRequest-hktw-skII',
        name: 'ADDITIONALREQUESTHKTWSKII',
        component: resolve => require(['@/view/SMILE/HKTWSOSRequest/SKIISOSRequest/index.vue'], resolve)
    },
    {
        path: '/AdditionalRequest-hktw',
        name: 'ADDITIONALREQUESTHKTW',
        component: resolve => require(['@/view/SMILE/HKTWSOSRequest/AdditionalRequest/index.vue'], resolve)
    },
    {
        path: '/oa-mtd-request-hktw',
        name: 'OAMTDREQUESTHKTW',
        component: resolve => require(['@/view/SMILE/HKTWSOSRequest/OAMTDRequest/index.vue'], resolve)
    },
    // Criteria Based Maintain
    {
        path: '/cbm/select-product',
        name: 'CBMSELECTPRODUCT',
        component: resolve => require(['@/view/CBM/select-product/index.vue'], resolve)
    },
    {
        path: '/cbm/select-product/success',
        name: 'CBMSELECTPRODUCTSUCCESS',
        component: resolve => require(['@/view/CBM/select-product/success.vue'], resolve)
    },
    {
        path: '/cbm/data-input',
        name: 'CBMDATAINPUT',
        component: resolve => require(['@/view/CBM/data-input/index.vue'], resolve)
    },
    {
        path: '/cbm/validation',
        name: 'CBMVALIDATION',
        component: resolve => require(['@/view/CBM/validation/index.vue'], resolve)
    },
    {
        path: '/cbm/differentiation-report',
        name: 'CBMDIFFERENTIATIONREPORT',
        component: resolve => require(['@/view/CBM/differentiation-report/index.vue'], resolve)
    },
        {
        path: 'hktw/pos-product-mapping-detail',
        name: 'POSPRODUCTMAPPINGDETAIL',
        component: resolve => require(['@/view/HKTW/components/PosProductMapping/PosProductMappingDetail.vue'], resolve)
    },
    // DPB Attributes 人工维护
    {
        path: '/dpb/attribute',
        name: 'DPBATTRIBUTE',
        component: resolve => require(['@/view/DPB/attribute/index.vue'], resolve)
    }
]



// WEBPACK FOOTER //
// ./src/router/product-price.js